import { createContext } from 'react';
var DEFAULT_CONTEXT = {
  defaultOpen: true,
  openOnError: false
};
export default createContext(DEFAULT_CONTEXT);